import { FC } from 'react'
import { OptionTypeBase, components, MenuProps } from 'react-select'
import { Drop, Params, Resp, getDrops } from './useDropsQuery'

// Components
import AsyncFilter from 'backoffice/components/DropRequests/Filters/AsyncFilter'

// Constants
const INPUT_SEARCH_THRESHOLD = 2
const PAGE = 1
const LIMIT = 10

// Custom components
const CustomMenu: FC<MenuProps<any, any>> = ({ selectProps, ...props }: any) => {
  if (selectProps.inputValue.length < INPUT_SEARCH_THRESHOLD) return null

  return (
    <>
      <components.Menu {...props} />
    </>
  )
}

type DropSearchboxProps = {
  onOptionSelected: (value: string) => void
}

const DropSearchbox: FC<DropSearchboxProps> = (props) => {
  // Props
  const { onOptionSelected } = props

  // Others
  const defaultConverter = (drop: Drop) => ({
    value: drop.id,
    label: `#${drop.id} ${drop.name}`,
  })

  const convertDropsToOptions = (paginatedDrops: Resp) => {
    return paginatedDrops.results.map<OptionTypeBase>(defaultConverter)
  }

  // TODO - Replace timeout with debounce hook - FR-199
  let timeoutId: NodeJS.Timeout

  const loadOptions = (inputValue: string = '', callback: (options: OptionTypeBase[]) => void) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    const doNothing = () => {
      callback([])
    }
    const runSearch = () => {
      timeoutId = setTimeout(async () => {
        const filter: Params = {
          search: inputValue,
          page: PAGE.toString(),
          limit: LIMIT.toString(),
        }

        try {
          const paginatedDrops = await getDrops(filter)
          const options = convertDropsToOptions(paginatedDrops)
          callback(options)
        } catch {
          callback([])
        }
      }, 300)
    }

    if (inputValue.length < INPUT_SEARCH_THRESHOLD) {
      doNothing()
    } else {
      runSearch()
    }
  }

  return (
    <AsyncFilter
      fetchItems={loadOptions}
      customComponents={[{ originalName: 'Menu', component: CustomMenu }]}
      onValueSelect={(value: any) => {
        onOptionSelected(value?.value ?? '')
      }}
    />
  )
}

export default DropSearchbox
